import { createSlotRecipe } from './runtime.js';

const buttonV2Config = {"name":"buttonV2","className":"button-v2","slots":["root"],"defaultVariants":{"variant":"quaternary"},"variantMap":{"variant":["impact","primary","quaternary","secondary","tertiary"]}}

export const buttonV2 = /* @__PURE__ */ createSlotRecipe(buttonV2Config)